import Vue from "vue";
import { provide } from "vue";
import App from "./App.vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import router from "@/router/index";
import store from "@/store/index";
import "uno.css";
import "normalize.css";
import "@/router/redirect";
import _ from "lodash";

require("@/styles/elementMobile-ui.scss");
require("@/styles/elementPc-ui.scss");
require("@/styles/iconfont/iconfont.css");//自定义图标

import { mapGetters } from "vuex";

const globalMixin = {
  computed: {
    ...mapGetters(['isMobileMode']),
  }
};
// 将混入对象应用到所有组件
Vue.mixin(globalMixin);

Vue.config.productionTip = false;
Vue.prototype.$store = store;
Vue.use(ElementUI);

Vue.directive("loadmore", {
  bind(el, binding) {
    const selectWrap = el.querySelector(".el-table__body-wrapper");
    selectWrap.addEventListener("scroll", function () {
      let sign = 10;
      const scrollDistance =
        this.scrollHeight - this.scrollTop - this.clientHeight;
      if (scrollDistance <= sign) {
        binding.value();
      }
    });
  },
});

import InfiniteLoading from "vue-infinite-loading";
Vue.use(InfiniteLoading, {
  slots: {
    noResults: "",
    noMore: "",
    spinner: "数据加载中...",
  },
});




new Vue({
  router,
  store,
  setup() {
    provide("router", router);
    provide("store", store);
    provide("_", _);
  },
  render: (h) => h(App),
}).$mount("#app");
